// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import PageTransition from './components/functionality/PageTransition';
// import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import ServicesPage from './pages/ServicesPage';
import FormPage from './pages/FormPage';
import VulnerabilityPage from './pages/VulnerabilityPage';
// import EventsPage from './pages/EventsPage';
import CounselingPage from './pages/CounselingPage';
import SubstancePage from './pages/SubstancePage';
import { Toaster } from 'react-hot-toast';
import ScrollToTop from './components/functionality/ScrollToTop';
import AppointmentPage from './pages/AppointmentPage';
import SelfTest from './pages/SelfTest';
import ThankYouPage from './pages/ThankYouPage';
import MedicalRecord from './pages/MedicalRecord';
import Vaccine from './pages/Vaccine';
import ScannerPage from './pages/ScannerPage';
import { CurpProvider } from './context/CurpContext';
import Footer from './components/Footer';
import QrDisplay from './pages/QrDisplay';
import ManageAppointmentPage from './pages/ManageAppointmentPage';

const AnimatedRoutes = () => {
  const location = useLocation();
  
  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<PageTransition><HomePage /></PageTransition>} />
        <Route path="/services" element={<PageTransition><ServicesPage /></PageTransition>} />
        <Route path="/services/counseling" element={<PageTransition><CounselingPage /></PageTransition>} />
        <Route path="/services/counseling/substance" element={<PageTransition><SubstancePage /></PageTransition>} />
        <Route path="/services/counseling/appointment" element={<PageTransition><AppointmentPage /></PageTransition>} />
        <Route path="/services/counseling/substance/appointment" element={<PageTransition><AppointmentPage /></PageTransition>} />
        <Route path="/services/self-test" element={<PageTransition><SelfTest /></PageTransition>} />
        <Route path="/services/self-test/counseling" element={<PageTransition><CounselingPage /></PageTransition>} />
        <Route path="/services/self-test/counseling/appointment" element={<PageTransition><AppointmentPage /></PageTransition>} />
        <Route path="/services/self-test/counseling/substance" element={<PageTransition><SubstancePage /></PageTransition>} />
        <Route path="/services/self-test/counseling/substance/appointment" element={<PageTransition><AppointmentPage /></PageTransition>} />

        {/* MEDICAL */}
        <Route path="/services/medical-service/medical-record" element={<PageTransition><MedicalRecord /></PageTransition>} />
        <Route path="/services/vaccine/medical-record" element={<PageTransition><MedicalRecord /></PageTransition>} />
        <Route path="/services/vaccine" element={<PageTransition><Vaccine /></PageTransition>} />
        <Route path="/services/medical-service/medical-record/appointment" element={<PageTransition><AppointmentPage /></PageTransition>} />
        <Route path="/services/vaccine/medical-record/appointment" element={<PageTransition><AppointmentPage /></PageTransition>} />
        <Route path="/services/medical-record/vaccine/appointment" element={<PageTransition><AppointmentPage /></PageTransition>} />
        <Route path="/form" element={<PageTransition><FormPage /></PageTransition>} />
        <Route path="/vulnerability" element={<PageTransition><VulnerabilityPage /></PageTransition>} />
        <Route path="/events/counseling" element={<PageTransition><CounselingPage /></PageTransition>} />
        {/* Registro simplificado */}
        <Route path='/rapido' element={<PageTransition><HomePage /></PageTransition>} />
        <Route path='/test/simplified/consent' element={<PageTransition><CounselingPage /></PageTransition>} />
        <Route path='/test/simplified/qrdisplay/:id' element={<PageTransition><QrDisplay /></PageTransition>} />
        <Route path="/events/counseling/simplified" element={<PageTransition><CounselingPage /></PageTransition>} />
        <Route path="/appointment" element={<PageTransition><AppointmentPage /></PageTransition>} />
        <Route path="/thank-you" element={<PageTransition><ThankYouPage /></PageTransition>} />
        {/* Agrega las rutas para las otras páginas de servicios aquí */}
        {/* Un solo escáner: reconoce si el QR es de una cita o de un evento.
            /scanner-events se conserva por las tablets que ya la tienen guardada. */}
        <Route path="/scanner" element={<PageTransition><ScannerPage /></PageTransition>} />
        <Route path="/scanner-events" element={<PageTransition><ScannerPage /></PageTransition>} />
        <Route path="/citas/gestionar/:token" element={<PageTransition><ManageAppointmentPage /></PageTransition>} />
      </Routes>
    </AnimatePresence>
  );
};

const App = () => {
  return (
    <Router>
      <ScrollToTop />
      <div className="min-h-screen">
        <CurpProvider>
          <Toaster />
          <AnimatedRoutes />
          <Footer />
        </CurpProvider>
      </div>
    </Router>
  );
};

export default App;
